import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  tableCellClasses,
  Typography,
} from "@mui/material";

// Styled components for table
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: "bold",
    fontSize: "1rem",
    padding: theme.spacing(1.5),
    whiteSpace: "normal", // Allow wrapping in headers if needed
    wordBreak: "break-word", // Break long words
    minWidth: "130px", // Minimum width for each header cell
    maxWidth: "250px", // Maximum width to prevent overly wide headers
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: "0.9rem",
    padding: theme.spacing(1.2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    whiteSpace: "normal", // Allow text wrapping
    wordBreak: "break-word", // Break long words
    minWidth: "130px", // Minimum width for each cell
    maxWidth: "250px", // Maximum width to prevent overly wide cells
    overflow: "hidden", // Hide overflow
    textOverflow: "ellipsis", // Add ellipsis for overflowing text
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: theme.palette.action.selected,
    transition: "background-color 0.2s ease",
  },
  "&:last-child td, &:last-child th": {
    borderBottom: 0,
  },
}));

const Guest150Table = ({ paginatedCustomers }) => {
  return (
    <TableContainer
      component={Paper}
      elevation={3}
      sx={{
        borderRadius: "8px",
        overflow: "hidden",
        maxWidth: "1200px", // Max table width
        minWidth: "650px", // Min table width
        margin: "auto",
        overflowX: "auto", // Enable horizontal scrolling on small screens
      }}
    >
      <Table aria-label="guest table">
        <TableHead>
          <TableRow>
            <StyledTableCell scope="col">Full Name</StyledTableCell>
            <StyledTableCell scope="col">Email</StyledTableCell>
            <StyledTableCell scope="col">Phone</StyledTableCell>
            <StyledTableCell scope="col">Location</StyledTableCell>
            <StyledTableCell scope="col" align="right">
              Total Guest Count
            </StyledTableCell>
            <StyledTableCell scope="col" align="right">
              Event Date
            </StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedCustomers.length > 0 ? (
            paginatedCustomers.map((customer) => {
              const eventDetails =
                JSON.parse(customer.eventDetails || "[]")[0] || {};
              return (
                <StyledTableRow key={customer.Id}>
                  <StyledTableCell>{customer.FullName}</StyledTableCell>
                  <StyledTableCell>{customer.Email}</StyledTableCell>
                  <StyledTableCell>{customer.Phone}</StyledTableCell>
                  <StyledTableCell>{customer.Location}</StyledTableCell>
                  <StyledTableCell align="right">
                    {eventDetails.totalGuestCount || "N/A"}
                  </StyledTableCell>
                  <StyledTableCell align="right">
                    {new Date(eventDetails.eventDate).toLocaleString() || "N/A"}
                  </StyledTableCell>
                </StyledTableRow>
              );
            })
          ) : (
            <StyledTableRow>
              <StyledTableCell colSpan={6} align="center">
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ py: 2 }}
                >
                  No customers found with 150+ total guest count.
                </Typography>
              </StyledTableCell>
            </StyledTableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Guest150Table;
